import React from 'react';
import { X } from 'lucide-react';

const LABELS = {
  category: 'الفئة',
  status: 'الحالة',
  priority: 'الأولوية',
  region: 'المنطقة',
  governorate: 'المحافظة',
  education_office: 'إدارة التعليم',
  school_id: 'المدرسة',
  contractor: 'المقاول',
  date_from: 'من تاريخ',
  date_to: 'إلى تاريخ',
};

const STATUS_MAP = { open: 'المفتوحة', completed: 'المكتملة' };

function isActive(v) {
  if (v === undefined || v === null || v === '' || v === 'all') return false;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

export default function ActiveFilterChips({ filters, options, onRemoveValue, onRemoveKey, onClearAll }) {
  const schoolNameById = React.useMemo(() => {
    const m = {};
    (options?.schools || []).forEach((s) => { m[s.id] = s.name; });
    return m;
  }, [options]);

  const chips = [];
  Object.entries(filters).forEach(([k, v]) => {
    if (k === 'period') return;
    if (!isActive(v)) return;
    if (Array.isArray(v)) {
      v.forEach((val) => {
        const disp = k === 'status' && STATUS_MAP[val] ? STATUS_MAP[val] : String(val);
        chips.push({ key: k, value: val, label: LABELS[k] || k, display: disp, isArray: true });
      });
    } else if (k === 'school_id') {
      chips.push({ key: k, value: v, label: LABELS[k], display: schoolNameById[v] || `ID ${v}`, isArray: false });
    } else {
      chips.push({ key: k, value: v, label: LABELS[k] || k, display: String(v), isArray: false });
    }
  });

  if (chips.length === 0) return null;

  return (
    <div className="panel px-3 py-2 mb-3 flex items-center gap-2 flex-wrap">
      <span className="text-slate-400 text-[11.5px] font-semibold">الفلاتر النشطة:</span>
      {chips.map((c, i) => (
        <span key={`${c.key}-${c.value}-${i}`} className="inline-flex items-center gap-1.5 rounded-full bg-blue-500/15 border border-blue-500/30 text-blue-200 text-[11.5px] py-1 pr-2.5 pl-1">
          <span className="text-blue-300/70">{c.label}:</span>
          <span className="font-semibold truncate max-w-[160px]" title={c.display}>{c.display}</span>
          <button onClick={() => (c.isArray ? onRemoveValue(c.key, c.value) : onRemoveKey(c.key))}
            className="w-4 h-4 rounded-full hover:bg-blue-500/40 flex items-center justify-center transition-colors" aria-label="remove">
            <X size={11} />
          </button>
        </span>
      ))}
      <button onClick={onClearAll} className="text-slate-400 hover:text-red-400 text-[11.5px] font-medium mr-auto transition-colors">
        مسح الكل
      </button>
    </div>
  );
}
